document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.btn-cart-icon').forEach(btn => {
    btn.addEventListener('click', function () {
      if (this.disabled || this.classList.contains('adding')) return;
      this.classList.add('adding');

      setTimeout(() => {
        this.classList.remove('adding');
        this.classList.add('added');

        const outline = this.querySelector('.icon-cart-outline');
        const check = this.querySelector('.icon-check');
        if (outline && check) {
          outline.classList.add('hidden');
          check.classList.remove('hidden');
        }

        setTimeout(() => {
          this.classList.remove('added');
          if (outline && check) {
            check.classList.add('hidden');
            outline.classList.remove('hidden');
          }
        }, 2000);
      }, 400);
    });
  });
});